<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content>
    <span [innerHTML]="data.message"></span>
</div>
<div mat-dialog-actions align="end">
    <button class="btn btn-primary" type="button" [mat-dialog-close]="true" cdkFocusInitial>{{data.positiveButtonText}}</button>
    <button class="btn btn-secondary" type="button" [mat-dialog-close]="false">{{data.negativeButtonText}}</button>
</div>